module.exports = "/images/bg_everest66.jpg?3287c58dc5a6bd465b2cc2437e9408fe";